import { Component } from '@angular/core';
import { CmpsDialogRef } from '@cmps/ng-uikit';

import { TranslationKeyMap } from '../coaching-commitment.i18n';

@Component({
    selector: 'cmps-commitment-disputed-goal-dialog',
    template: ` <button
            class="cmps-commitment-disputed-goal-dialog--close"
            cmpsIconButton
            (click)="_dialogRef?.close()"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
        <div class="cmps-commitment-disputed-goal-dialog--body">
            {{
                _i18n._9815_THIS_GOAL_IS_BEING_DISPUTED__THIS_IS_THE_VERSION_
                    | translate
            }}
        </div>
        <div class="cmps-commitment-disputed-goal-dialog--actions">
            <button
                class="cmps-outline-button--sm"
                cmpsOutlineButton
                (click)="_dialogRef?.close()"
            >
                <span cmpsOutlineButtonLabel>{{
                    _i18n._9425_OK | translate
                }}</span>
            </button>
        </div>`,
    host: {
        class: 'cmps-commitment-disputed-goal-dialog',
    },
})
export class DisputedGoalDialogComponent {
    /** @private */ _i18n = TranslationKeyMap;

    constructor(
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            DisputedGoalDialogComponent,
            any
        >,
    ) {}
}
